var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags)?_c('div',{staticClass:"absolute top-0 right-0 flex gap-1"},_vm._l((_vm.tags.slice(0, 3).filter(function (t) { return t; })),function(tag,index){return _c('a-tag',{key:index,staticClass:"sidebar-dropdown__tag mr-0",class:{
      'rounded-tr-none rounded-br-none': index === _vm.tags.length - 1
    },attrs:{"color":tag.color}},[_vm._v(" "+_vm._s(tag.text)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }